<div class="body ui container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">API Key</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <!-- <button (click)="deleteTemplate()" class="ui small basic primary  icon button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="remove lookup data">
                <i class="trash alternate icon"></i>
                </button> -->
      <div class="ui medium labeled button">
        <button
          class="ui text button primary"
          (click)="generateKey()"
          [disabled]="!applicationForm.valid"
        >
          <div>Generate Key</div>
        </button>
        <a
          class="ui basic label"
          style="width: 300px"
          [formGroup]="applicationForm"
        >
          <!-- {{totalItems}} Record(s) -->
          <select
            name=""
            id=""
            style="width: 100%; border: none; outline: none"
            formControlName="applicationId"
          >
            <option value="" disabled selected>Select Application</option>
            <option [value]="a.applicationId" *ngFor="let a of applicationList">
              {{ a.applicationName }}
            </option>
          </select>
        </a>
      </div>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <div *ngIf="success || error">
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <!-- <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0"> -->
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <!-- <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div> -->
      <div fxFlex="10%">HITS COUNTS</div>
      <div fxFlex="15%">DATE LAST ACCESSED</div>
      <div fxFlex="15%">CREATED BY</div>
      <div fxFlex="15%">DATE CREATED</div>
      <div fxFlex="grow">KEY</div>
      <div fxFlex="20%"></div>
    </div>

    <div
      class="ui segment"
      *ngFor="let apikey of apiKeys"
      appMargin
      marginB="3"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
    >
      <!-- <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div> -->
      <div fxFlex="10%">{{ apikey?.hitsCount }}</div>
      <div fxFlex="15%">{{ apikey?.dateLastAccessed | date }}</div>
      <!-- <div fxFlex><span class="ui green label" [ngClass]="{'green':apikey.status == 'IN-ACTIVE'}">{{apikey?.status}}</span></div> -->
      <div fxFlex="15%">
        {{ apikey?.appUserId?.firstName }} {{ apikey?.appUserId?.lastName }}
        {{ apikey?.appUserId?.middleName }}
      </div>
      <div fxFlex="15%">
        {{
          apikey?.dateCreated
            | amLocale: "en"
            | amDateFormat: "MMMM Do YYYY, h:mm a"
        }}
      </div>
      <div fxFlex="grow">
        <span class="ui label"
          ><code> {{ apikey?.apiKey | truncate: 45 }}</code></span
        >
      </div>
      <div fxFlex="20%" class="text-right">
        <button
          class="ui tiny primary basic button"
          [clipboard]="apikey.apiKey"
          (clipboardCopy)="logSuccess($event)"
          (clipboardError)="logError($event)"
        >
          Copy Key
        </button>
        &nbsp;
        <button
          class="ui circular tiny button"
          (click)="delete(apikey)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Delete Key"
        >
          <i class="trash icon"></i>
        </button>
      </div>
    </div>
    <app-no-record-found
      *ngIf="apiKeys && apiKeys.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button" (click)="getPage(1)">
            <i class="refresh icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
